/**
 * ⚖️ BALANCE MODULE - Re-exports for backward compatibility
 *
 * This module combines:
 * - config.js: Core balance constants (BALANCE)
 * - advisors.js: Advisor definitions
 * - specializations.js: Building specialization paths
 * - utils.js: Helper functions
 *
 * Import from here for backward compatibility:
 *   import { BALANCE, calculateBuildingCost } from '../data/balance';
 *
 * Or import from specific files for better tree-shaking:
 *   import { BALANCE_CONFIG } from '../data/balance/config';
 *   import { calculateBuildingCost } from '../data/balance/utils';
 */

import { BALANCE_CONFIG } from './config';
import { ADVISORS } from './advisors';
import { SPECIALIZATIONS } from './specializations';

// Re-export all utility functions
export {
  // Building helpers
  calculateBuildingCost,
  // Building capacity helpers
  getBuildingCapacity,
  getPanelBuildingCount,
  getBuildingCapacityInfo,
  getOutpostBuildingCount,
  // Research helpers
  getBaseResearchTime,
  calculateResearchTime,
  getResearchSpeedMultiplier,
  // Tech cost helpers
  getTechCostMultiplier,
  getScaledTechCost,
  // Time formatting
  formatTime,
  // Production helpers
  calculateProduction,
  // Kingdom tier helpers
  getKingdomTier,
  getPlayerEra,
  // Click power helpers
  getClickPower,
  // Quest helpers
  getQuestRewardMultiplier,
  getQuestObjectiveMultiplier,
  getScaledQuestRewards,
  getScaledQuestObjectives,
} from './utils';

// Build the unified BALANCE object for backward compatibility
// This merges config with advisors and specializations
export const BALANCE = {
  ...BALANCE_CONFIG,
  advisors: ADVISORS,
  specializations: SPECIALIZATIONS,
};

// Re-export individual modules for direct access
export { BALANCE_CONFIG } from './config';
export { ADVISORS } from './advisors';
export { SPECIALIZATIONS } from './specializations';

// Default export for `import BALANCE from '../data/balance'`
export default BALANCE;
